import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { UserDataService } from 'src/app/services/user-data/user-data.service';

@Injectable({
  providedIn: 'root'
})
export class AutoLoginGuard  {

  constructor(
    private router: Router,
    private userData: UserDataService
  ) { }
  
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.hasUserLoggedIn();
  }

  async hasUserLoggedIn(): Promise<boolean | UrlTree> {

    if (await this.userData.hasLoggedIn()) {
      return this.router.parseUrl('/dashboard');
    }
    else {
      return true;
    }
  }
}
